import { Device } from 'components/Device'
import InconsistentIcon from 'components/Icons/InconsistentIcon'
import { useMemo } from 'react'
import './styles.scss'

interface CardMemberProps {
  title: string
  description?: string
  cpf?: string
  familyHead?: boolean
  isInconsistent?: boolean
  listIsInconsistent?: string[]
}

function CardMember({
  title,
  description,
  cpf,
  familyHead = false,
  isInconsistent = false,
  listIsInconsistent = [],
}: CardMemberProps) {
  const device = Device.useDevice()

  const devicePrefix = device.prefix()

  const messageCorrected = useMemo(() => {
    const isContentBirthDate = listIsInconsistent?.some(
      (info: string) => info === 'birthDate'
    )
    const isContentGender = listIsInconsistent?.some(
      (info: string) => info === 'gender'
    )

    if (isContentBirthDate && !isContentGender) {
      return 'A data de nascimento desse membro está inconsistênte entre as bases.'
    }
    if (isContentGender && !isContentBirthDate) {
      return 'O gênero desse membro está inconsistênte entre as bases.'
    }

    return 'O gênero e a data de nascimento desse membro estão inconsistentes entre as bases.'
  }, [title])
  return (
    <div
      className={`container-cardMember ${devicePrefix ?? 'undefined'} ${
        familyHead ? 'familyHead' : ''
      }`}
    >
      <div className="cardMember-content">
        <div>
          <h2>
            {isInconsistent && (
              <div>
                <InconsistentIcon
                  isNoticeOfInconsistenciesTooltip={true}
                  message={messageCorrected}
                  width="15"
                  height="15"
                />
              </div>
            )}

            {title}
          </h2>
          <p style={{ fontStyle: 'italic' }}>{description}</p>
        </div>
        <div>
          <h2>CPF</h2>
          <p>{cpf ?? 'Não tem informação'}</p>
        </div>
      </div>
    </div>
  )
}

export default CardMember
